function extractTrackInfo(track) {
    const { id, label, kind, contentHint, enabled, muted, readyState } = track;
    return {
        id,
        label,
        kind,
        contentHint,
        enabled,
        muted,
        readyState,
        settings: track.getSettings(),
        constraints: track.getConstraints(),
        capabilities: track.getCapabilities(),
    };
}
function extractStreamInfo(stream) {
    return {
        id: stream.id,
        active: stream.active,
        video: stream.getVideoTracks().map(extractTrackInfo),
        audio: stream.getAudioTracks().map(extractTrackInfo),
    };
}
export function extractStreamInfos(streams) {
    return streams
        .map((stream) => (stream ? extractStreamInfo(stream) : undefined))
        .filter((stream) => !!stream);
}
